"use client"

import { Box } from "@chakra-ui/react/box"
import { type FC, useEffect, useRef } from "react"

import { type HtmlBlock as HtmlBlockType } from "@/types/database"

const replaceScriptElements = (root: ParentNode) => {
  root.querySelectorAll("script").forEach((scriptNode) => {
    const templateNode = document.createElement("template")
    templateNode.setAttribute("data-ignored-script", "")
    scriptNode.replaceWith(templateNode)
  })
}

interface HtmlBlockProps {
  block: HtmlBlockType
}

const HtmlBlock: FC<HtmlBlockProps> = ({ block }) => {
  const { raw_code } = block
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const container = containerRef.current

    if (!container) {
      return
    }

    container.innerHTML = ""

    const template = document.createElement("template")
    template.innerHTML = raw_code
    replaceScriptElements(template.content)

    container.append(template.content.cloneNode(true))

    return () => {
      container.innerHTML = ""
    }
  }, [raw_code])

  return (
    <Box className="html-block  edge-to-edge" position="relative">
      <Box
        css={{
          "& a": {
            color: "primary.500",
            textDecoration: "underline",
          },
          "& iframe": {
            maxWidth: "100%",
          },
          "& img": {
            borderRadius: "lg",
            height: "auto",
            maxWidth: "100%",
          },
        }}
        ref={containerRef}
      />
    </Box>
  )
}

export default HtmlBlock
